import React, { useEffect, useState } from 'react';
import { Card, Spin } from 'antd';
import { EntryCardEnhanced } from './EntryCard';
import { QuestionnaireEnhanced } from './Questionnaire';
import { TableQuestions } from './TableQuestions';
import { GameProfileItem, GameProfileResponse } from '../../../types/gameProfile';
import { getGameProfilesRepository } from '../../../repository/mytm/gameProfile/gameProfileRepository';
import { logging } from '../../../utils/log';
import SelectButtons from '../../atoms/select-buttons/SelectButtons';
import { useCountrySelection } from '../../../hooks/useCountrySelection';

export const MyGameProfile: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [entryCard, setEntryCard] = useState<GameProfileItem | null>(null);
  const [questionnaire, setQuestionnaire] = useState<GameProfileItem | null>(null);
  const [countrySelected, setCountrySelected] = useCountrySelection(null);

  const loadData = async (country?: string | null) => {
    try {
      setLoading(true);
      const response: GameProfileResponse = await getGameProfilesRepository(country);

      // Separate data by type
      const entryCardData = response.gameProfiles.find(item => item.type === 'ENTRY_CARD') || null;
      const questionnaireData = response.gameProfiles.find(item => item.type === 'QUESTIONNAIRE') || null;

      setEntryCard(entryCardData);
      setQuestionnaire(questionnaireData);
    } catch (error) {
      logging(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (countrySelected) {
      loadData(countrySelected);
    }
  }, [countrySelected]);

  const handleEntryCardSave = (data: GameProfileItem) => {
    setEntryCard(data);
  };

  const handleQuestionnaireSave = (data: GameProfileItem) => {
    setQuestionnaire(data);
  };

  const handleRefresh = () => {
    loadData(countrySelected);
  };

  return (
    <div style={{ padding: 24 }}>
      <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 20 }}>My Game Profile</h1>

      <SelectButtons onChangeValue={(item: string) => setCountrySelected(item)} />

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          <EntryCardEnhanced data={entryCard} onSave={handleEntryCardSave} country={countrySelected} />

          <QuestionnaireEnhanced data={questionnaire} onSave={handleQuestionnaireSave} country={countrySelected} />
          <Card style={{ marginTop: 24 }}>
            <TableQuestions onRefresh={handleRefresh} country={countrySelected} />
          </Card>
        </>
      )}
    </div>
  );
};
